module.exports = __webpack_public_path__ + "static/Google puzzle@2x-d177f36c3e5af66a94d9614779c4de6d.png";